/* eslint-disable radix */
import React from 'react';
import Pagination from 'react-js-pagination';
import { I18n } from 'react-redux-i18n';

const TablePagination = (props) => {
  const {
    numberOfItems, numberOfItemsForPage, activePage, showItemsCount,
  } = props;

  function renderProductsCount() {
    const skip = ((activePage - 1) * numberOfItemsForPage);
    let numberOfPages = numberOfItems / numberOfItemsForPage;
    if (numberOfItems % numberOfPages !== 0 || numberOfPages < 1) {
      numberOfPages = parseInt(numberOfPages += 1);
    }

    if (numberOfItems > 0) {
      return (
        <p>
          {I18n.t('showing')}
          {' '}
          {skip === 0 ? '1' : skip}
          {' '}
          {I18n.t('a')}
          {' '}
          {numberOfPages === activePage ? numberOfItems : (activePage * numberOfItemsForPage)}
          {' '}
          {I18n.t('de')}
          {' '}
          {numberOfItems}
          {' '}
          {I18n.t('registros')}
        </p>
      );
    }
  }


  return (
    <div className="main-table">
      {showItemsCount && renderProductsCount()}
      <Pagination
        activePage={activePage}
        itemsCountPerPage={numberOfItemsForPage}
        totalItemsCount={numberOfItems}
        pageRangeDisplayed={5}
        onChange={props.setPage}
      />

    </div>
  );
};
export default TablePagination;
